import { REMOVE_EVENT_LISTENER } from '../constants/MethodNames';
import { callingAPIMethodWithQueue } from '../utils/hsCallingUtils';
export default function removeCallingEventListener(event) {
  return callingAPIMethodWithQueue(REMOVE_EVENT_LISTENER, event);
}